import $ from 'jquery';
import './jquery.cookie';
import dayjs from 'dayjs';
import {get} from 'lodash';
import {usgaUtils} from './usga.utils';
import {usgaConfig} from './usga.config';
import {ProtectedContentModal} from '../modules/modal/modal-protected-content';

const UA = window.UA;

const gigyaCallbacks = {};
let gigyaConfig,
	gigyaLoaded = false,
	gigyaReady = false,
	gigyaLoggedIn = false,
	gigyaUser = null,
	connectedMember = null,
	redirectionUrl = '';

const addCallback = function (type, callback) {
	let callbacks = gigyaCallbacks[type];
	if (!callbacks) {
		callbacks = gigyaCallbacks[type] = [];
	}
	callbacks.push(callback);
};

const executeCallbacks = function (type) {
	const callbacks = gigyaCallbacks[type];
	if (callbacks) {
		const args = usgaUtils.getArgs(arguments, 1);
		$.each(callbacks, function (i, callback) {
			executeCallback.apply(null, [callback].concat(args));
		});
	}
};

var executeCallback = function (callback) {
	if (typeof callback === 'function') {
		const args = usgaUtils.getArgs(arguments, 1);
		callback.apply(null, args);
	}
};

const onGigyaEvent = function (event, data) {
	window.gigyaLastEvent = '';
	if (event === 'gigya-loaded') {
		gigyaLoaded = true;
		setTimeout(getGigyaAccountInfo, 10);
	} else if (~['login-successful', 'register-successful', 'register-fan-successful', 'login-connect-successful', 'connect-account-successful'].indexOf(event)) {
		const expDate = data.memberExpDate ? new Date(data.memberExpDate) : false;

		window.gigyaLastEvent = event;

		//We should not set akamai cookie for fan/prospect/members expired beyond 30 day grace period
		if (expDate && dayjs(expDate).isValid() && dayjs() < dayjs(expDate).add(1, 'month')) {

			//we need to set this to true as akamai requires its value to not being encoded. By default jquery cookie encodes it.
			$.cookie.raw = true;
			$.cookie('__LoggedIn__', data.akamaiToken, {
				expires: 30,
				path: '/',
				domain: 'usga.org'
			});
		}

		let timeout = 10;

		//TODO Ping Gigya team to investigate safari delay issue.
		//For some reason only safari browser doesn't login after registration without 1000ms timeout.
		if ((event === 'register-successful' || event === 'register-fan-successful') && usgaUtils.browser.safari) {
			timeout = 1000;
		}
		setTimeout(getGigyaAccountInfo, timeout);

	} else if (event === 'logout') {
		Gigya.resetDtm();
		setLoginSessionState(true);
		$.cookie('__LoggedIn__', null, {path: '/'});
		$.removeCookie('__LoggedIn__', {path: '/'});
		setGigyaUser(null);
		executeCallbacks('logout');
	} else if (event === 'connect-member-id') {
		connectedMember = data;
		executeCallbacks('connect-member-id');
	} else if (event === 'close-popup') {
		executeCallbacks('close-popup');
	}
};

const inSsoContext = function () {
	return usgaUtils.url.query.show === 'sso';
};

var setLoginSessionState = function (remove) {
	if (remove) {
		$.removeCookie('sessionLogin', {
			path: '/'
		});
	} else {
		$.cookie('sessionLogin', true, {
			path: '/'
		});
	}
};

const getLoginSessionState = function () {
	return $.cookie('sessionLogin') !== undefined;
};

var getGigyaAccountInfo = function () {
	if (!UA) return;
	UA.gigya.accounts.getAccountInfo({
		callback: function (response) {
			const user = (response.status == 'OK') ? response : null;
			setGigyaUser(user);
			if (!isAemAuthEnv() && Gigya.isUserOnProtectedContentPage() && !Gigya.isUserHasAccessToProtectedContent()) {
				document.location.href = usgaConfig.clubhouseHomeUrl;
			}
			if (user) {
				executeCallbacks('login', gigyaUser);
				if (redirectionUrl && Gigya.isUserHasAccessToProtectedContent()) {
					document.location.href = redirectionUrl;
				}
				if (inSsoContext() && !Gigya.isUserHasAccessToProtectedContent()) {
					Gigya.openMembershipExpiredDialog();
				}

				Gigya.setDtm();
				if (!getLoginSessionState()) {
					setLoginSessionState();
					Gigya.trackDtm();
				}
			} else {
				if (!gigyaReady && inSsoContext()) {
					if (usgaUtils.url.query.target) {
						Gigya.setRedirectionUrl(usgaUtils.url.query.target);
					}
					Gigya.openNotLoggedInDialog();
				}
			}
			if (!gigyaReady) {
				gigyaReady = true;
				executeCallbacks('ready', gigyaUser);
			}
		},
		include: 'profile,data',
		extraProfileFields: 'address,phones'
	});
};


const getGigyaAccountData = function (cb) {
	if (!UA) {
		return;
	}

	UA.gigya.accounts.getAccountInfo({
		callback: function (response) {
			const user = (response.status == 'OK') ? response : null;

			setGigyaUser(user, true);
			if (typeof cb === 'function') {
				cb(user);
			}
		},
		include: 'profile,data',
		extraProfileFields: 'address,phones'
	});
};

const getGigyaDataStore = function (userId, callback) {
	//we don't need to load datastore object on all pages, so we will have users to run this explicitly
	if (!UA) return;

	UA.gigya.ds.get({
		type: 'Member',
		oid: userId,
		callback: function (response) {
			if (response.status == 'OK') {
				executeCallback(callback, response);
			} else {
				console.warn('DataStore object can not be retrieved.');
				executeCallback(callback);
			}
		}
	});
};

const getProfileMailingAddress = function (userId) {
	if (!UA) {
		usgaUtils.log('usga.Gigya: UA is not available');
		return;
	}

	const d = $.Deferred(), pending = $.Deferred();

	pending.promise().then(function (profile) {
		if (profile) {
			UA.gigya.ds.get({
				oid: userId,
				type: 'Member',
				callback: function (response) {
					if (!usgaUtils.isObject(response)) {
						usgaUtils.log('usga.Gigya: wrong ds response');
						d.resolve(false);
					}
					if (response.status === 'OK') {
						const address = response.data && response.data !== null && response.data.address &&
						response.data.address !== null && response.data.address.shipping &&
						response.data.address.billing !== null && usgaUtils.isObject(response.data.address.shipping) ?
							response.data.address.shipping : {};

						profile.address1 = profile.address && profile.address !== null ? profile.address : '';
						profile.address2 = address.address2 && address.address2 !== null ? address.address2 : '';

						d.resolve(profile);
					}
					else {
						usgaUtils.log('usga.Gigya: ' + response.errorMessage);
						d.resolve(false);
					}
				}
			});
		}
		else {
			d.resolve(false);
		}
	});

	UA.gigya.accounts.getAccountInfo({
		callback: function (response) {
			if (!usgaUtils.isObject(response)) {
				usgaUtils.log('usga.Gigya: wrong info response');
				pending.resolve(false);
			}
			if (response.status == 'OK') {
				pending.resolve(response.profile &&
				response.profile !== null && usgaUtils.isObject(response.profile) ? response.profile : {});
			}
			else {
				usgaUtils.log('usga.Gigya: ' + response.errorMessage);
				pending.resolve(false);
			}
		},
		include: 'profile',
		extraProfileFields: 'address'
	});

	return d.promise();
};

const setProfileMailingAddress = function (userId, updatedAddress) {
	if (!UA) {
		usgaUtils.log('usga.Gigya: UA is not available');
		return;
	}

	const d = $.Deferred(),
		serializedData = JSON.stringify(updatedAddress),
		xhr = $.ajax(
			{
				url: usgaConfig.gigyaBaseServiceUrl.replace(/\/+$/, '') + '/Services/SetProfileData.ashx',
				method: 'post',
				dataType: 'jsonp',
				data: {
					uid: userId,
					apiKey: usgaConfig.gigyaApiKey,
					data: serializedData
				}
			}
		);
	xhr.done(function (response) {
		if (!usgaUtils.isObject(response)) {
			usgaUtils.log('usga.Gigya: wrong response');
			d.resolve(false);
		}
		if (response.status === 'success') {
			d.resolve(true);
		}
		else {
			usgaUtils.log('usga.Gigya: ' + response.error);
			d.resolve(false);
		}
	});
	xhr.fail(function (xhr, textStatus) {
		usgaUtils.log('usga.Gigya: ' + textStatus);
		d.resolve(false);
	});

	return d.promise();
};

var setGigyaUser = function (user, suppressCallback) {
	gigyaUser = user;
	gigyaLoggedIn = !!user;
	if (!suppressCallback) {
		executeCallbacks('user', user);
	}
};

const executeGigyaDisplay = function (action, options) {
	if (!UA) return;
	UA.display($.extend(options, {
		action: action
	}));
};

var isAemAuthEnv = function () {
	return (window.CQ !== undefined);
};

let Gigya = {

	init: function (config) {
		if (!UA) return;
		gigyaConfig = $.extend({}, config, {
			eventHandler: onGigyaEvent
		});
		UA.init(gigyaConfig);
		this.onLogin($.proxy(this._onProtectedContentModalEvent, this));
	},

	isReady: function () {
		return gigyaReady;
	},

	setDtm: function () {
		let loginState = 'User not logged in';
		if (gigyaUser) {
			if (this.isFederatedUserOutsideRenewalWindow()) {
				loginState = 'Federated User outside renewal window';
			}
			else if (this.isExpiringFederatedUserWithinRenewalWindow()) {
				loginState = 'Federated User within renewal window';
				loginState = 'Federated User within renewal window';
			}
			else if (this.isExpiredFederatedUser()) {
				loginState = 'Expired Federated User';
			}
			else if (this.isLapsedFederatedUser()) {
				loginState = 'Lapsed Federated User';
			}
			else if (this.isFan()) {
				loginState = 'Logged In Fan Account';
			}
			else if (this.isProspect()) {
				loginState = 'Logged in Prospect Account';
			}
		}
		usgaUtils.setDtm({
			user: {
				loginstate: loginState,
				id: (gigyaUser ? gigyaUser.UID : ''),
				level: (gigyaUser && gigyaUser.data ? gigyaUser.data.memberLevel : '')
			}
		});
	},

	resetDtm: function () {
		$.extend(window.digitalData, {user: null});
	},

	trackDtm: function () {
		usgaUtils.trackDtm('userlogin', {});
	},

	isLoggedIn: function () {
		return gigyaLoggedIn;
	},

	isMember: function () {
		if (gigyaUser) {
			const data = gigyaUser.data;
			return !!data.memberExpDate;
		}
	},

	isMembershipActual: function () {
		if (gigyaUser) {
			const data = gigyaUser.data;
			const expDate = data.memberExpDate;
			if (expDate) {
				return dayjs().add(1, 'month') < dayjs(new Date(expDate));
			}
		}
	},

	isMembershipActualOrInGracePeriod: function () {
		if (gigyaUser) {
			const data = gigyaUser.data;
			const expDate = data.memberExpDate;
			if (expDate) {
				return dayjs() < dayjs(new Date(expDate)).add(1, 'month');
			}
		}
	},

	isExpiredMember: function () {
		return this.isMember() && !this.isMembershipActual();
	},

	isUserState: function (state) {
		let isUserState = false;
		if (gigyaUser) {
			const data = gigyaUser.data;

			if (data.memberExpDate) {
				const now = dayjs(),
					expDate = new Date(data.memberExpDate);

				switch (state) {
					case 'standard-active':
						isUserState = now.add(45, 'day') < dayjs(expDate);
						break;

					case 'standard-expiring':
						isUserState = now.add(45, 'day') >= dayjs(expDate);
						break;

					case 'standard-expired':
						isUserState = dayjs(expDate).add(30, 'day') < now;
						break;

					case 'standard-in-grace':
						isUserState = (dayjs(expDate).add(30, 'day') >= now) && dayjs(expDate) < now;
						break;

					default:
						isUserState = false;
						break;
				}
			}
		}
		return isUserState;
	},

	isExpiringFederatedUserWithinRenewalWindow: function () {
		if (gigyaUser && this.isMember()) {
			if (gigyaUser.data.memberExpDate) {
				const expDate = new Date(gigyaUser.data.memberExpDate);

				return dayjs().add(6, 'M') > dayjs(expDate) && dayjs() < dayjs(expDate);
			}
		}
	},

	isFederatedUserOutsideRenewalWindow: function () {
		if (gigyaUser && this.isMember() && !this.isExpiredMember()) {
			const expDate = gigyaUser.data.memberExpDate;

			if (expDate) {
				return dayjs().add(6, 'M') < dayjs(new Date(expDate));
			}
		}
	},

	isExpiredFederatedUser: function () {
		if (gigyaUser && this.isExpiredMember()) {
			const expDate = gigyaUser.data.memberExpDate;

			if (expDate) {
				return dayjs() < dayjs(new Date(expDate)).add(6, 'M');
			}
		}
	},

	isLapsedFederatedUser: function () {
		if (gigyaUser && this.isExpiredMember()) {
			return !this.isExpiredFederatedUser();
		}
	},

	isFan: function () {
		if (gigyaUser) {
			const data = gigyaUser.data;
			return !data.memberId && !data.memberExpDate;
		}
	},

	isProspect: function () {
		if (gigyaUser) {
			const data = gigyaUser.data;
			return data.memberId && !data.memberExpDate;
		}
	},

	getUser: function (callback) {
		if (gigyaReady) {
			executeCallback(callback, gigyaUser);
		} else {
			this.onReady(callback);
		}
	},

	getDataStore: function (callback) {
		Gigya.getUser(function (user) {
			if (user) {
				getGigyaDataStore(user.UID, callback);
			} else {
				executeCallback(callback);
			}
		});
	},

	getProfileMailingAddress: function () {
		if (gigyaUser) {
			return getProfileMailingAddress(gigyaUser.UID);
		}
		return $.when(false);
	},

	setProfileMailingAddress: function (updatedAddress) {
		if (gigyaUser) {
			return setProfileMailingAddress(gigyaUser.UID, updatedAddress);
		}
		return $.when(false);
	},

	getConnectedMember: function () {
		return connectedMember;
	},

	getAccountData: function (cb) {
		return getGigyaAccountData(cb);
	},

	login: function (options) {
		executeGigyaDisplay('sign-in', options);
	},

	logout: function () {
		if (UA) {
			UA.logout();
		}
	},

	loginRegister: function (options) {
		executeGigyaDisplay('login+register', options);
	},

	register: function (options) {
		executeGigyaDisplay('register', options);
	},

	campaignRegister: function () {
		this.register({campaign: true});
	},

	campaignLogin: function () {
		this.login({campaign: true});
	},

	profile: function (options) {
		executeGigyaDisplay('profile', options);
	},

	connect: function (options) {
		executeGigyaDisplay('connect-member-id', options);
	},

	connectAccount: function (options) {
		executeGigyaDisplay('connect-account', options);
	},

	isUserOnProtectedContentPage: function () {
		return (document.location.href.indexOf('/clubhouse/protected/') != -1);
	},

	isUserHasAccessToProtectedContent: function () {
		return (this.isLoggedIn() && this.isMember() && this.isMembershipActualOrInGracePeriod());
	},

	isSsoOpened: function () {
		return $('#overlayContainer:visible iframe').length !== 0;
	},

	_onProtectedContentModalEvent: function (user) {
		$.each(this._protectedContentModalEvents || {}, function (name, handler) {
			handler(user);
		});
	},

	setProtectedContentModalEvent: function (name, eventHandler) {
		this._protectedContentModalEvents = this._protectedContentModalEvents || {};
		if (eventHandler === null) {
			delete this._protectedContentModalEvents[name];
		}
		else {
			this._protectedContentModalEvents[name] = eventHandler;
		}
	},

	showProtectedContentModal: function (selector, disableClose) {
		if (!this.protectedContentModal && $('#protectedContentModal').length) {
			this.protectedContentModal = new ProtectedContentModal('#protectedContentModal');
		}
		if (this.protectedContentModal) {
			this.protectedContentModal.open(selector, disableClose);
		}
	},

	openNotLoggedInDialog: function () {
		this.showProtectedContentModal('.sign-in');
	},

	openNonMemberDialog: function () {
		this.showProtectedContentModal('.non-member');
	},

	openMembershipExpiredDialog: function () {
		this.showProtectedContentModal('.expired');
	},

	setRedirectionUrl: function (url) {
		redirectionUrl = url;
	},

	onReady: function (callback) {
		if (gigyaReady) {
			executeCallback(callback, gigyaUser);
		} else {
			addCallback('ready', callback);
		}
	},

	onLogin: function (callback) {
		addCallback('login', callback);
	},

	onLogout: function (callback) {
		addCallback('logout', callback);
	},

	onUser: function (callback) {
		addCallback('user', callback);
		if (gigyaReady) {
			executeCallback(callback, gigyaUser);
		}
	},

	onConnectMemberId: function (callback) {
		addCallback('connect-member-id', callback);
	},

	onClosePopup: function (callback) {
		addCallback('close-popup', callback);
	}
};

if (window.usga && window.usga.Gigya) {
	Gigya = window.usga.Gigya;
} else {
	Gigya.init({gigyaApiKey: get(window.globalSettings, 'gigya.apiKey')});
}

export {Gigya};